export class StoryblokManagementApiClient {
  private readonly accessToken: string;

  private readonly baseUrl: string;

  constructor({ accessToken, spaceId }: { accessToken: string; spaceId: string }) {
    this.accessToken = accessToken;

    const storyblokManagementApiBaseUrl = process.env.GATSBY_STORYBLOK_MANAGEMENT_API_BASE_URL;
    this.baseUrl = `${storyblokManagementApiBaseUrl}${spaceId}/`;
  }

  get(path: string) {
    return fetch(`${this.baseUrl}${path}`, {
      headers: {
        Authorization: this.accessToken,
      },
    });
  }
}
